<div class="card">
  <div class="card-title">
    {{label}} <span>{{slider?.value}}</span>
  </div>
  <div class="card-content">
    <aar-slider-group [slideData]="slider?.data"></aar-slider-group>
  </div>
</div>
